import { render, staticRenderFns } from "./tableTopBottom.vue?vue&type=template&id=5f9ca47d&"
import script from "./tableTopBottom.vue?vue&type=script&lang=js&"
export * from "./tableTopBottom.vue?vue&type=script&lang=js&"
import style0 from "./tableTopBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports